import { Controller } from "@hotwired/stimulus"

// Chat input behaviour: Enter sends, Shift+Enter makes a new line, the box
// grows with what's typed, and it clears once the question has actually been
// posted (not before — a failed request must not eat what the person typed).
export default class extends Controller {
  static targets = ["input"]

  // Beyond this the field scrolls instead of growing: on a phone a tall
  // composer pushes the conversation off the screen, which is the thing the
  // person is writing about.
  static MAX_HEIGHT_PX = 160

  connect() {
    this.grow()
  }

  submit(event) {
    if (event.shiftKey) return

    event.preventDefault()
    if (this.inputTarget.value.trim() === "") return

    this.element.requestSubmit()
  }

  clear(event) {
    if (!event.detail.success) return

    this.inputTarget.value = ""
    this.grow()
    this.inputTarget.focus()
    // Scrolling is the chat-scroll controller's job — it also handles the
    // answer arriving later, over Turbo Streams.
  }

  // Height follows content. Reset to `auto` first: scrollHeight never shrinks
  // below the height already set, so without it the field only ever grows.
  grow() {
    const input = this.inputTarget
    input.style.height = "auto"
    input.style.height = `${Math.min(input.scrollHeight, this.constructor.MAX_HEIGHT_PX)}px`
  }
}
